import axios from 'axios';
import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAuth } from '../../AuthContext';
import logo from '../../Assets/logo/skilletix.png';
import SuccessModal from "../shared/SuccessModal";
import Breadcrumb from '../Breadcrumb';


const Login = () => { 
  const [showModal, setShowModal] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    success: false,
    message: "",
  });
  const [credentials, setCredentials] = useState({ usernameOrEmail: '', password: '' });
  const [error, setError] = useState('');
  const [loader, setLoader] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  
  const navigate = useNavigate();
  const location = useLocation(); 
  const { login } = useAuth();

  useEffect(() => {
    const loadGoogleScript = () => {
      const script = document.createElement('script');
      script.src = 'https://accounts.google.com/gsi/client';
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);

      script.onload = () => {
        if (window.google) {
          initializeGoogleSignIn();
        }
      };
    };

    const initializeGoogleSignIn = () => {
      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,
        callback: handleGoogleSignIn,
      });

      window.google.accounts.id.renderButton(
        document.getElementById('google-signin-button'),
        { theme: 'outline', size: 'large', width: '100%' }
      );
    };

    loadGoogleScript();

    return () => {
      const scriptTag = document.querySelector('script[src="https://accounts.google.com/gsi/client"]');
      if (scriptTag) {
        document.body.removeChild(scriptTag);
      }
    };
  }, []);

  const handleGoogleSignIn = async (response) => {
    try {
      setLoader(true);
      setError("");

      const url = `${process.env.REACT_APP_API_URL}users/google-login`;
      const backendResponse = await axios.post(url, {
        idToken: response.credential
      });

      const user = backendResponse.data;

      if (backendResponse.status === 202) {
        if (user.userType === "admin") {
          setModalConfig({
            success: false,
            message: "Please log in at admin portal; this is only for candidates and employees."
          });
          setShowModal(true);
        } else {
          localStorage.setItem('jwttoken', user.token);
          localStorage.setItem('userid', user.userId);
          localStorage.setItem('userType', user.userType);

          setTimeout(() => {
            login(user.userType, user.token);
            if (window.history.length > 2) {
              navigate(-1);
            } else {
              if (user.userType === "candidate") {
                navigate("/candidatedashboard");
              } else if (user.userType === "employer") {
                localStorage.setItem("companyId", user.companyId);
                navigate("/employerdashboard");
              }
            }
            setTimeout(() => {
              window.history.pushState(null, "", window.location.pathname);
              window.history.forward();
            }, 100);
          }, 100);
        }
      }
    } catch (err) {
      if (err.response) {
        const { status, data } = err.response;

        if (status === 401) {
          setError("Google authentication failed. Please try again.");
        } else if (status === 422) {
          setError("Account not found. Please register first.");
        } else if (status === 500) {
          setError("Unable to connect to the server. Please check your internet connection or try again later.");
        }
      } else {
        setError("Google login failed. Please try again later.");
      }
    } finally {
      setLoader(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials({
      ...credentials,
      [name]: value
    });
  };
  
        useEffect(() => {
            if (error) {
              const timer = setTimeout(() => {
                setError(null);
              }, 3000); 
        
              return () => clearTimeout(timer); 
            }
          }, [error]);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoader(true);
    setError("");  

    const trimmedCredentials = {
      usernameOrEmail: credentials.usernameOrEmail.trim(),
      password: credentials.password.trim()
    };
    try {
      const headers = {
        'x-access-token': localStorage.getItem('jwttoken')
      };
      const url = `${process.env.REACT_APP_API_URL}users/login`;
      const response = await axios.post(url, trimmedCredentials, { headers });

      const user = response.data;
      if (response.status === 202) {
        if (user.userType === "admin") {
          setModalConfig({
            success: false,
            message: "Please log in at admin portal; this is only for candidates and employees."
          });
          setShowModal(true);
        } else {
          localStorage.setItem('jwttoken', user.token);
          localStorage.setItem('userid', user.userId);
          localStorage.setItem('userType', user.userType);
          if (user.userType === "employer") {
            localStorage.setItem('companyId', user.companyId);
          }

          
          login(user.userType, user.token);
          
          const dashboardRoute = user.userType === "candidate" 
            ? "/candidatedashboard" 
            : "/employerdashboard";
          
          navigate(dashboardRoute, { 
            state: { 
              from: location.pathname 
            } 
          });
        }
      }
    } catch (err) {
      if (err.response) {
        const { status, data } = err.response;

        if (status === 401) {
          setError("Incorrect Password. Please try again");
        } else if (status === 422) {
          setError("User not found. Please check your credentials");
        } else if (status === 500) {
          setError("Unable to connect to the server. Please check your internet connection or try again later.");
        }
      } else {
        setError("Login Failed. Please try again later");
      }
    } finally {
      setLoader(false);
    }
  };

  return (
    <>
      <ToastContainer />
      {/* <div className="site-breadcrumb">
        <div className="container">
          <h2 className="breadcrumb-title">Sign In</h2>
          <ul className="breadcrumb-menu">
            <li>
              <a href="index.html">Home</a>
            </li>
            <li className="active">Sign In</li>
          </ul>
        </div>
        <div className="hero-shape">
          <img
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high" className="hero-shape-1" src="assets/img/shape/03.svg" alt="" />
          <img
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high" className="hero-shape-2" src="assets/img/shape/05.svg" alt="" />
          <img
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high" className="hero-shape-3" src="assets/img/shape/06.svg" alt="" />
          <img
          loading="lazy"
          role="presentation"
          decoding="async"
          fetchpriority="high" className="hero-shape-4" src="assets/img/shape/07.svg" alt="" />
        </div>
      </div> */}
      <Breadcrumb
        title="Sign In"
        path={[
          { label: "Home", href: "/", active: false },
          { label: "Sign In", active: true }
        ]}
      />
      <div className="login-area py-120">
        <div className="container">
          <div className="col-md-8 col-lg-7 col-xl-5 mx-auto">
            <div className="login-form">
              <div className="login-header">
                <img src={logo} alt="" />
                <p>Login with your Skilletix account</p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="form-group">
                  <label>Email Address</label>
                  <input
                    className="form-control"
                    name='usernameOrEmail'
                    type='text'
                    placeholder='Username, Email, or Mobile'
                    required
                    value={credentials.usernameOrEmail}
                    onChange={handleInputChange}
                  />
                </div>
                <div className="form-group">
                  <label>Password</label>
                  <div className="position-relative">
                    <input
                      className="form-control pe-5"
                      name="password"
                      type={showPassword ? "text" : "password"}
                      placeholder="Password"
                      required
                      value={credentials.password}
                      onChange={handleInputChange}
                    />
                    <i
                      className={`fas position-absolute top-50 translate-middle-y end-0 me-3 ${
                        showPassword ? "fa-eye-slash" : "fa-eye"
                      }`}
                      style={{ cursor: "pointer" }}
                      onClick={() => setShowPassword(!showPassword)}
                    ></i>
                  </div>
                </div>
                <div className="d-flex justify-content-between mb-4">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      defaultValue=""
                      id="remember"
                    />
                    <label className="form-check-label" htmlFor="remember">
                      Remember Me
                    </label>
                  </div>
                  <Link to="/forgot-password" className="forgot-pass">
                    Forgot Password?
                  </Link>
                </div>
                {error && <p className="alert alert-danger">{error}</p>}
                <div className="d-flex align-items-center">
                  <button type="submit" className="theme-btn" disabled={loader}>
                    {loader ? "Signing In..." : <><i className="far fa-sign-in" /> Sign In</>}
                  </button>
                </div>
              </form>

              <div className="login-separator">
                <span>OR</span>
              </div>

              <div className="social-login">
                <div id="google-signin-button" className="mb-3"></div>
              </div>

              <div className="login-footer">
                <p>
                  Don't have an account? <Link to={"/register"}>Sign Up.</Link>
                </p>
                <p>
                  Register as a employer <Link to={"/register-employer"}>Register.</Link>
                </p>
              </div>
            </div>
            <SuccessModal
              show={showModal}
              onClose={() => setShowModal(false)}
              success={modalConfig.success}
              message={modalConfig.message}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;